import React from 'react';
import { Redirect } from 'react-router-dom';
import { authRoles } from 'app/auth';

// Heidi Storage section. The nav labels are short (Overview, Documents, Imaging,
// Fast Storage) because the user is already inside Heidi; each page carries the
// full product name in its header.
export const StorageOverviewConfig = {
	settings: { layout: { config: {} } },
	auth: [...authRoles.user, ...authRoles.instructor, ...authRoles.participant],
	routes: [
		{
			path: '/storage',
			exact: true,
			component: React.lazy(() => import('./StoragePage'))
		},
		{
			path: '/storage/imaging',
			exact: true,
			component: React.lazy(() => import('./StorageImaging'))
		},
		{
			path: '/storage/fast',
			exact: true,
			component: React.lazy(() => import('./StorageFast'))
		},
		// Documents moved under the Storage section. Existing links and bookmarks
		// (Pace and Adelphi are live on /documents) must keep working.
		{
			path: '/documents',
			exact: true,
			component: () => <Redirect to="/storage/documents" />
		}
	]
};
